<div class="addressbar">
  <span class="addresstext">Sustav / Firme</span>
</div>
<div class="containerpadding">
  <mat-card appearance="outlined">
    <mat-card-title>
      Firme
    </mat-card-title>

    <p *ngIf="!lista"><em>Učitavam...</em></p>
    <hr />

    <mat-card-actions>
      <button routerLink="add" mat-stroked-button class="add-color"><mat-icon aria-hidden="false" aria-label="Dodavanje">add</mat-icon> Nova</button>&nbsp;
      <button (click)="EditData()" mat-stroked-button class="edit-color"><mat-icon aria-hidden="false" aria-label="Ispravak">edit</mat-icon> Ispravak</button>&nbsp;
      <button (click)="openDialog()" mat-stroked-button class="delete-color"><mat-icon aria-hidden="false" aria-label="Brisanje">delete</mat-icon> Briši</button><br />
    </mat-card-actions>
    <mat-form-field>
      <mat-label>Traži</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Tekst">
    </mat-form-field>
    <div class="mat-elevation-z6">
      <table *ngIf="lista" mat-table [dataSource]="lista" matSort style="width:100%">

        <ng-container matColumnDef="sifra">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Šifra </th>
          <td mat-cell *matCellDef="let element"> {{element.sifra}} </td>
        </ng-container>

        <ng-container matColumnDef="naziv">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Naziv </th>
          <td mat-cell *matCellDef="let element"> {{element.naziv}} </td>
        </ng-container>

        <ng-container matColumnDef="oib">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> OIB </th>
          <td mat-cell *matCellDef="let element"> {{element.oib}} </td>
        </ng-container>

        <ng-container matColumnDef="ulica">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Ulica </th>
          <td mat-cell *matCellDef="let element"> {{element.ulica}} </td>
        </ng-container>

        <ng-container matColumnDef="mjesto">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Naselje </th>
          <td mat-cell *matCellDef="let element"> {{element.mjesto}} </td>
        </ng-container>
        <ng-container matColumnDef="iban">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> IBAN </th>
          <td mat-cell *matCellDef="let element"> {{element.iban}} </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row;columns: displayedColumns;" [ngClass]="{highlight: selectedrow.id === row.id}" (click)="highlight(row)"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[ 10, 20,50]" showFirstLastButtons></mat-paginator>
    </div>
  </mat-card>
  <hr />
  </div>
